import { render } from "./HalfVacationIcon.vue?vue&type=template&id=21e33e80"
import script from "./HalfVacationIcon.vue?vue&type=script&lang=js"
export * from "./HalfVacationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__